import * as JsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export default {
  props: ['idTabela', 'orientacao', 'tituloTabela','descricoes','entrada', 'retorno','resultados','nomeArquivo','nomeImagemParceiro'],
  created(){
    console.log(this.entrada)
  },

  data () {
    return {
      tamanhoLinha: 0,
      tamanhoTotal: 0
    }
  },
  methods: {
    configuraSubtitulo (opcoes) {
       opcoes.headerStyles={}
       opcoes.headerStyles.fillColor=[96,168,216] 
       opcoes.headerStyles.halign = "left"
       opcoes.startY-=5
    },

 
    gerarOpcoes (doc, espacamento, numeroPagina, linhas, titulo, primeiro) {

      let vm = this;
      let poweredText;
      let pageCounter;
      let titleMarginLeft;

       if (this.orientacao === 'p') {
        poweredText = 570;
        pageCounter = 400;
        titleMarginLeft = 250;
      } else {
        poweredText = 570;
        pageCounter = 660;
        titleMarginLeft = 400;
      }

      let header = function (data) {
        doc.setFontSize(16);
        doc.setTextColor(40);
        doc.setFontStyle('normal');
        doc.text(titleMarginLeft, 36, "");

        doc.setFontStyle('normal');
 
      };

      let footer = function(data) {
        doc.setFontSize(10);
        if (numeroPagina !== doc.internal.getNumberOfPages()) {
          vm.tamanhoLinha = 0
          espacamento = 0
          numeroPagina = doc.internal.getNumberOfPages()
          doc.text(40, poweredText, String(numeroPagina))
          doc.text(pageCounter, poweredText, 'Powered by Rancho Soluções');
        } 
      };

      let py = [];
      
      let options = {
        theme: 'striped',
        startY: primeiro ? 140 : doc.autoTableEndPosY() + 5,
        styles: {
          overflow: 'linebreak',
        },
        margin: {
          top: 30,
          bottom: 30
        },
        columnStyles:{
          0: {
            columnWidth: 260,
            fontSize: 9
          },
          1: {
            columnWidth:130,
            fontSize: 9,
            halign: 'right',
            fontStyle: 'bold'
          },
          2: {
            columnWidth:260,
            fontSize: 9,
          },
          3: {
            columnWidth:130,
            fontSize: 9,
            halign: 'right',
            fontStyle: 'bold'                    
          }
         
        },
        drawHeaderRow (row, data) {
          py.push(row.y + 15)
        },
        drawRow (row, data) {
          vm.tamanhoLinha += row.height
          vm.tamanhoTotal += row.height
          if (vm.tamanhoLinha >= 560 ) {
            vm.tamanhoLinha = 0
            doc.addPage()
            espacamento = 0
          }
        },
        addPageContent: (data) => {
          header(data);
          footer(data);
          
          if (titulo) {
            let titulos = Array.isArray(titulo) ? titulo : [titulo]
            let posY = py.pop()
            for(var i = 0; i < titulos.length; i++) {
              let titulo = titulos[i]
              doc.setTextColor (255,255,255)
              doc.setFontSize (12)
              doc.setFontType ("bold")
              if (titulo.subtitulo) {
                doc.text(titulo.texto, 50, posY)
              } else {
                if (titulo.subtitulo1) {
                  doc.text(titulo.texto, 440, posY)
                } else {
                  doc.text(titulo, 425, posY, 'center')
                }  
              }
            }

          }
        },
        drawCell: (cell, data) => {
        
        }
      };

      return {
        opcoes: options,
        numeroPagina: numeroPagina,
        espacamento: espacamento
      };

    },
    criarPDF () {

      let doc = new this.$JsPDF(this.orientacao, 'pt');
      
      this.entrada = this.$utils.exportaPdf.trataEntrada(this.entrada)

      let espacamento = 0;
      let numeroPagina = 0;
      let opcoes = {};
      let resp = {};
      this.tamanhoLinha = 0
      this.tamanhoTotal = 0

      this.$utils.exportaPdf.adicionaLogosConsolidado(doc, this.nomeImagemParceiro)    

      //*==============================================================================
      //Relatório Consolidado (Pasto Básico)
      //*==============================================================================
      
      doc.setFontType ("bold")
      doc.text ('Relatório Consolidado (Pasto Básico) ',250,30)
      
      let px = 280
      let px2 = 425
      doc.setFontSize (12)
      doc.setFontType ("normal")
      doc.text ('Nome da simulação:',px,50)
      doc.setFontType ("bold")
      doc.text (this.entrada.nome,px2,50)
      doc.setFontType ("normal")
      doc.text ("Data da simulação:",px,70)
      doc.setFontType ("bold")
      doc.text (this.retorno.criado_em,px2,70)
      doc.setFontType ("normal")
      doc.text ("Estágio do negócio:",px,90)
      doc.setFontType ("bold")
      doc.text (this.entrada.estagioNegocio,px2,90)
      doc.setFontType ("normal")

      doc.setFontSize (14)
         
           
      //============================================================================================== 
      // Informações Produtivas e financeiras
      //==============================================================================================

      let colunas =  ['',
      '',
      '',
      '']

      let linhas = [                  
      
      [this.descricoes.items.dataD1.titulo,
      this.entrada.dataD1,
      this.descricoes.items.pesoInicial.titulo,
      this.entrada.pesoInicialKg + ' kg'],
      
      [this.descricoes.items.valorGadoCIF.titulo,
      'R$ ' + this.entrada.valorGadoCIF + ' /cab',
      this.descricoes.items.dataDZ.titulo,
      this.entrada.dataDZ],
      
      [this.descricoes.items.pesoFinal.titulo,
      this.entrada.pesoFinalKg + ' kg',
      this.descricoes.items.custeioMensal.titulo,
      'R$ ' + this.entrada.custeioMensal + ' /cab/mês'],
                          
      [this.descricoes.items.precoVendaLivre.titulo,
        'R$ ' + this.entrada.precoVendaLivre + '/@',
      this.descricoes.items.rendimentoDeCarcacaDoAbate.titulo,
      this.entrada.rendimentoDeCarcacaDoAbate + ' %'],

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Informações Produtivas e financeiras", true)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      colunas =  ['',
      '',
      '',
      '']

      linhas = [                    
                                            
      [this.descricoes.items.pesoEntradaArroba.titulo,
      this.resultados.pesoEntradaArroba + ' @',
      this.descricoes.items.gmdKgD.titulo,
      this.resultados.gmdKgD + " Kg/dia"],

      [this.descricoes.items.custoArrobaEntradaMagra.titulo,
      'R$ ' + this.resultados.custoArrobaEntradaMagra + ' /@',
      this.descricoes.items.pesoSaidaArroba.titulo,
      this.resultados.pesoSaidaArroba + ' @'],

      [this.descricoes.items.ganhoCarcacaKgd.titulo,
      this.resultados.ganhoCarcacaKgd + ' kg/dia',
      this.descricoes.items.custoArrobaProduzida.titulo,
      'R$ ' + this.resultados.custoArrobaProduzida  + ' /@'],

      [this.descricoes.items.producaoArrobaPorCabeca.titulo,
      this.resultados.producaoArrobaPorCabeca + ' @/cab' ,
      this.descricoes.items.rendimentoGanho.titulo,
      this.resultados.rendimentoGanho + ' %'],

      [this.descricoes.items.custoArrobaVendida.titulo,
      'R$ ' + this.resultados.custoArrobaVendida + ' /@',
      this.descricoes.items.cicloProdutivoMeses.titulo,
      this.resultados.cicloProdutivoMeses],

      [this.descricoes.items.diasParaGanhar1Arroba.titulo,
      this.resultados.diasParaGanhar1Arroba,
      this.descricoes.items.pontoEquilibrioCusteio.titulo,
      'R$ ' + this.resultados.pontoEquilibrioCusteio + ' /cab/mês'],
    
      [this.descricoes.items.cicloProdutivoDias.titulo,
      this.resultados.cicloProdutivoDias,
      this.descricoes.items.quantidadeArrobaGanhasCabecaMes.titulo,
      this.resultados.quantidadeArrobaGanhasCabecaMes + ' @'],

      [this.descricoes.items.pontoEquilibrioValorGado.titulo,
      'R$ ' + this.resultados.pontoEquilibrioValorGado + ' /cab',
      this.descricoes.items.pontoEquilibrioArrobaVendidaLivre.titulo,
      'R$ ' + this.resultados.pontoEquilibrioArrobaVendidaLivre + ' /@'],

      [this.descricoes.items.lucroLiquido.titulo,
      'R$ '+ this.resultados.lucroLiquido + ' /cab',
      this.descricoes.items.lucratividadeOperacao.titulo,
      this.resultados.lucratividadeOperacao + ' %'],
                        
      [this.descricoes.items.rentabilidadeOperacao.titulo,
      this.resultados.rentabilidadeOperacao + ' %',
      this.descricoes.items.taxaMensalCapitalInvestidoGado.titulo,
      this.resultados.taxaMensalCapitalInvestidoGado + ' %'] 

    ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Econômicos", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)
    
    
      doc.save(this.nomeArquivo) 
  }
 }
}                    


// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Simples/Pasto/Exports/ExportarPDFeXLSController.js